import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { ImageUpload } from 'components/ImageUpload';
import { LAYOUT } from 'components/Layout';

import { useImageUpload } from '../api/uploadImage';
import { IconWrapper } from 'components/Icon';

export const BannerImage = ({ sx = {}, banner, bannerChangable = false, refetch = null, smallHeight = false, pointer = false, companyId: companyIdProp = null }) => {
  const { id: idParam } = useParams();
  const companyId = companyIdProp || idParam;
  const [open, setOpen] = useState(false);

  const { mutate: uploadImage } = useImageUpload(companyId, 'background', refetch);

  return (
    <>
      <ImageUpload
        title="Upload banner image"
        image={banner}
        open={open}
        aspect={8 / 1}
        handleClose={() => setOpen(false)}
        uploadImage={uploadImage}
        modalSx={{
          width: LAYOUT.width,
        }}
        cropHeight={340}
      />

      <Box
        onClick={() => {
          if (bannerChangable) setOpen(true);
        }}
        width={LAYOUT.width}
        minHeight={smallHeight ? LAYOUT.smallHeaderHeight : LAYOUT.largeHeaderHeight}
        // position="absolute"
        top={0}
        left={0}
        sx={({ spacing }) => ({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: (bannerChangable || pointer) ? 'pointer' : 'default',
          borderBottom: '1px solid',
          borderBottomColor: 'grey.200',
          // bgcolor: 'grey.300',
          overflow: 'hidden',

          img: {
            // borderRadius: `0px 0px ${spacing(2)} ${spacing(2)}`,
            height: 1,
            width: 1,
            // objectFit: { xs: 'fill', lg: 'cover' },
          },
          ...sx,
        })}
      >
        {!banner && (
          <IconWrapper
            icon="photo"
            sx={{ svg: { width: 80, height: 80, mt: -4, stroke: 'grey.300', color: 'grey.300' } }}
          />
        )}

        {banner && <img src={banner} alt="banner" />}
      </Box>
    </>
  );
};
